// Default packages
// ----------------

// jQuery
window.$ = window.jQuery = require('jquery');

// Bootstrap
require('bootstrap');

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//Moment.js
window.moment = require('moment');
require('moment/locale/nl');

// jQuery validation
require('jquery-validation');

// Final countdown
require('jquery-countdown');

// Optional packages
// -----------------

// Slick
require('slick-carousel');

//select2
require('select2');
require('select2/src/js/select2/i18n/nl');
require('select2/src/js/select2/i18n/fr');
$.fn.select2.defaults.set('amdLanguageBase', 'select2/i18n/');

//autocomplete
require('devbridge-autocomplete/dist/jquery.autocomplete');

// Lightbox
// window.lightbox = require('lightbox2').option({
//     'albumLabel': '%1 / %2'
// });

// Bootstrap Datepicker
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.nl');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');

//mask
require('inputmask/dist/jquery.inputmask');
